<div [ngClass]="expand ? 'rotate' : 'no-rotate'">
  <span [ngClass]="iconClassArray()" class="text-2xl"><IIcon name="chevronRight" /></span>
</div>
